import request from "../../utils/request";
import {
  UserPayslipView,
  UserPayslipInput,
  UserPayslipRequestInput,
  BulkNotifyPayslipsInput,
  BulkGeneratePayslipsInput
} from "../../models/payroll";
import { Result } from "../../models/general";

export interface PagedResult<T> {
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  items: T[];
}

export async function GetUserCompanyDepartments() {
  const response = await request.get<Result<UserPayslipView[]>>("UserPayslip/GetUserCompanyDepartments");
  return response.data;
}

//departments for a specific user
export async function GetUserDepartment() {
  const response = await request.get<Result<UserPayslipView[]>>("UserPayslip/GetUserCompanyDepartments");

  if (response.data.status === 200 && response.data.payload && response.data.payload.length > 0) {
    return response.data.payload[0];
  }
  return null;
}

export async function GetUserPayslips(input: UserPayslipRequestInput) {
  const response = await request.post<Result<PagedResult<UserPayslipView>>>("UserPayslip/GetUserPayslips", input);
  return response.data;
}

export async function GetUserPayslipById(id: number) {
  const response = await request.get<Result<UserPayslipView>>(`UserPayslip/GetUserPayslipById/${id}`);
  return response.data;
}

export async function GeneratePayslipFromPayroll(input: UserPayslipInput) {
  const response = await request.post<Result<boolean>>("UserPayslip/GeneratePayslipFromPayroll", input);
  return response.data;
}

export async function UpdateUserPayslip(input: UserPayslipInput) {
  const response = await request.put<Result<boolean>>("UserPayslip/UpdateUserPayslip", input);
  return response.data;
}

export async function DeleteUserPayslip(id: number) {
  const response = await request.delete<Result<boolean>>(`UserPayslip/DeleteUserPayslip/${id}`);
  return response.data;
}

export async function DownloadPayslipPdf(payslipId: number) {
  const response = await request.get(`UserPayslip/DownloadPayslipPdf/${payslipId}`, { responseType: 'blob' });
  // Create download link
  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `payslip-${payslipId}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export async function PreviewPayslipPdf(payslipId: number) {
  const response = await request.get(`UserPayslip/PreviewPayslipPdf/${payslipId}`, { responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
  window.open(url, '_blank');
}

export async function BulkDownloadPayslips(payslipIds: number[]) {
  const response = await request.post("UserPayslip/BulkDownloadPayslips", payslipIds, { responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `payslips-${Date.now()}.zip`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
  return true;
}

export async function BulkNotifyPayslips(input: BulkNotifyPayslipsInput) {
  const response = await request.post<Result<boolean>>("UserPayslip/BulkNotifyPayslips", input, {
    headers: { 'Content-Type': 'application/json' }
  });
  return response.data;
}

export async function BulkGenerateFromPayroll(input: BulkGeneratePayslipsInput) {
  const response = await request.post<Result<boolean>>("UserPayslip/BulkGenerateFromPayroll", input, {
    headers: { 'Content-Type': 'application/json' }
  });
  return response.data;
}
